import store from "../service/store";
import { TicketAdminGroupType } from "@share/ticketSystem/enums/TicketAdminGroupTypes";

const getParamGetter = (): ((serviceName: string, paramName: string) => unknown) => {
    return store.getters['services/getServiceParam'];
}

export const ticketSystemIsEnabled = () => {
    const paramGetter = getParamGetter();
    return !!paramGetter('ticketSystem', TicketAdminGroupType.ideasAdministrationGroupIds)
        || !!paramGetter('ticketSystem', TicketAdminGroupType.problemsAdministrationGroupIds);
}

export const getServiceParamValue = (serviceName: string, paramName: string) => {
    const paramGetter = getParamGetter();
    return paramGetter(serviceName, paramName);
}
